import { object } from 'common/helpers'


export const initialState = {
  isFetching: false,
  isFetched: false,
  items: [],
}

export const setFetching = (state, payload) => (
  { ...state, isFetching: payload }
)

export const setItems = (state, payload /* items */) => (
  object.merge(state, {
    items: payload,
    isFetched: true,
    isFetching: false,
  })
)

export const addItem = (state, payload /* item */) => (
  object.update(state, 'items', (items) => {
    const res = items.slice()
    res.push(payload)
    return res
  })
)

export const clear = (state, payload) => {} // TODO remove?
